import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { FormatDateTimePipe, ListOfFirmwarePackage } from '@ottobock/remote-update/domain';

import { FirmwareTableDataSource } from './firmware-table-datasource';

@Component({
  standalone: true,
  selector: 'remote-update-feature-remote-update-dashboard-firmware-table',
  templateUrl: './firmware-table.component.html',
  styleUrl: './firmware-table.component.css',
  imports: [
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressBarModule,
    FormatDateTimePipe
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None
})
export class FirmwareTableComponent implements AfterViewInit, OnChanges {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatTable) table!: MatTable<ListOfFirmwarePackage>;
  router = inject(Router);

  @Input() packages: ListOfFirmwarePackage[] | null = [];

  dataSource = new FirmwareTableDataSource([]);

  displayedColumns = [
    'bundle_version',
    'state',
    'description',
    'used_in_rollout_plans',
    'updated_at'
  ];

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.table.dataSource = this.dataSource;
  }

  ngOnChanges(): void {
    this.refreshTable();
  }

  private refreshTable() {
    if (this.packages) {
      this.dataSource.setFirmwarePackageData(this.packages);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;

      if (this.table) {
        this.table.dataSource = this.dataSource;
      }
      if (this.paginator) {
        this.paginator._changePageSize(this.paginator.pageSize);
      }
    }
  }
  goToDetails(firmwarePackage: ListOfFirmwarePackage): void {
    this.router.navigate(['firmware-package/details', firmwarePackage.id]);
  }
}
